export const modulesAccess = ['member', 'event', 'lobby', 'training', 'invitation', 'request', 'admin'];

export default { modulesAccess };
